import {withStyles} from '@material-ui/core/styles'
import React from 'react'
import {TopToolbar, CreateButton, Datagrid, EditButton, List, TextField,} from 'react-admin'

const styles = theme => ({
  title: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
  hiddenOnSmallScreens: {
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  }
})
const Actions = ({basePath,}) => (
  <TopToolbar>
    <CreateButton basePath={basePath}/>
  </TopToolbar>
)

export default withStyles(styles)(({classes, ...props}) => {
  return (
    <List {...props}
          actions={<Actions/>}
          bulkActionButtons={false}>
      <Datagrid>
        <TextField source="id" sortable={false}/>
        <TextField source="affiliation" sortable={false}/>
        <EditButton/>
      </Datagrid>
    </List>
  )
})

